import { QueryClient, useQuery } from '@tanstack/react-query';
import { SystemApi } from 'api/ApiHelper';
import { systemQueryKey } from 'queries/system/queryKey';

export const useGetFeatureFlagConfigsQuery = () =>
  useQuery({
    queryKey: systemQueryKey.featureFlagConfig(),
    queryFn: () => SystemApi.getFeatureFlags(),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 10,
  });

export const prefetchFeatureFlagQuery = async (queryClient: QueryClient) =>
  queryClient.prefetchQuery({
    queryKey: systemQueryKey.featureFlagConfig(),
    queryFn: () => SystemApi.getFeatureFlags(),
  });

export const fetchFeatureFlagQuery = async (queryClient: QueryClient) =>
  queryClient.fetchQuery({
    queryKey: systemQueryKey.featureFlagConfig(),
    queryFn: () => SystemApi.getFeatureFlags(),
  });
